

























import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
  InsertReportPdfStandard,
  UpdateReportPdfStandard
} from "@/api/reportSetting";

@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  @Prop() data: any;
  form: any = {};
  title: string = "";
  saveLoading = false;
  rules: any = {
    standardCode: [
      { required: true, message: "请输入规格编码", trigger: "blur" }
    ],
    width: [
      {
        type: "number",
        required: true,
        message: "请选择纸张宽度",
        trigger: "blur"
      }
    ],
    height: [
      {
        type: "number",
        required: true,
        message: "请选择纸张高度",
        trigger: "blur"
      }
    ]
  };

  created() {
    if (this.data.mode == "add") {
      this.title = "添加打印纸规格";
    } else {
      this.title = "修改打印纸规格";
      this.form = Object.assign({}, this.data.data);
    }
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  async save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.saveLoading = true;
        let res: any = {};
        if (this.data.mode == "edit") {
          res = await UpdateReportPdfStandard(this.form);
        } else {
          res = await InsertReportPdfStandard(this.form);
        }
        if (res.status == 1) {
          this.$emit("save-success");
          this.$emit("input", false);
        }
        this.saveLoading = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/reportSetting/standAddOrEdit.vue